const en: Record<string, string> = {
  'guitarChords.list.search': 'Search',
  'guitarChords.list.searchPlaceholder': 'Search by name…',
  'guitarChords.list.root': 'Root note',
  'guitarChords.list.fretFilter': 'Fret per string',
  'guitarChords.list.anyFret': '-',
  'guitarChords.list.add': 'Add chord',
  'guitarChords.list.loadError': 'Could not load the chord inventory.',
  'guitarChords.list.deleteTitle': 'Delete chord',
  'guitarChords.list.deleteMessage': 'Remove "{{name}}" from the inventory?',
  'guitarChords.form.name': 'Name',
  'guitarChords.form.suggestName': 'Use suggested name: {{name}}',
  'guitarChords.form.rootNote': 'Root note',
  'guitarChords.form.description': 'Description',
  'guitarChords.form.addTitle': 'Add a chord',
  'guitarChords.form.editTitle': 'Edit chord',
  'guitarChords.difficulty.label': 'Difficulty',
  'guitarChords.difficulty.level0': 'Easy',
  'guitarChords.difficulty.level1': 'Simple',
  'guitarChords.difficulty.level2': 'Moderate',
  'guitarChords.difficulty.level3': 'Intermediate',
  'guitarChords.difficulty.level4': 'Hard',
  'guitarChords.difficulty.level5': 'Very hard',
};

export default en;
